import { useMemo } from 'react';

const useAdaptiveFontSize = (text, { baseRem, minRem }) => {
  return useMemo(() => {
    const len = (text || '').length;
    if (len <= 24) return `${baseRem}rem`;
    const computed = baseRem - (len - 24) * 0.02;
    const clamped = Math.max(minRem, computed);
    return `${clamped.toFixed(2)}rem`;
  }, [text, baseRem, minRem]);
};

export default useAdaptiveFontSize;
